import React, { useState, useEffect } from 'react';
import TeamCard from '../../../pages/team/TeamCard/TeamCard';
import ProgrammeInfo from '../ProgrammeInfo/ProgrammeInfo';
import * as queries from "../../../utils/prismicQueries";
import client from '../../../utils/prismicHelpers';

const InvestmentCommittee = () => {
    const [investerInfo, setInvesterInfo] = useState(null);
    useEffect(() => {
        client
            .query({
                query: queries.investerCommittee,
            })
            .then((response) => {
                const socialLinks = response.data.allInvestcommits.edges[0].node;
                setInvesterInfo(socialLinks);


            })
            .catch((error) => {
                console.error(error);
            });
    });
    return (
        <div   >
            <div className="row pt-5">
                <div className="col-md-6">
                    <ProgrammeInfo>
                        <h1 className="subtitle invester-title w-50 ">{investerInfo?.title[0]?.text}</h1>
                        <p className='body-text text-start'>{investerInfo?.description[0]?.text}</p>


                    </ProgrammeInfo>
                </div>
                <div className="col-md-6 ">
                    <div className="row gx-2">
                        {investerInfo?.inverster_info.map((team,index) =>
                            <TeamCard
                                key={index +1}
                                teamInfo={team}
                                isinvestment={true}
                            >

                            </TeamCard>)
                        }
                    </div>

                </div>
            </div>
        </div>
    );
};

export default InvestmentCommittee;